// Decelerating curve shared by every animation: fast start, soft landing.
export const STANDARD_EASING = [0.22, 1, 0.36, 1] as const;
